
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useIsMobile } from "@/hooks/use-mobile";

interface NotesFieldProps {
  value: string;
  onChange: (notes: string) => void;
}

export const NotesField = ({ value, onChange }: NotesFieldProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-1">
      <Label htmlFor="notes" className={isMobile ? "text-xs" : ""}>Notes (optional)</Label>
      <Textarea
        id="notes"
        placeholder="Add any notes about this birdie..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        className={isMobile ? "text-xs" : ""}
      />
    </div>
  );
};
